import React, { useState } from "react"
import { makeStyles } from "@material-ui/core/styles"
import Accordion from "@material-ui/core/Accordion"
import AccordionSummary from "@material-ui/core/AccordionSummary"
import AccordionDetails from "@material-ui/core/AccordionDetails"
import Typography from "@material-ui/core/Typography"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import { useTranslation } from "react-i18next"

const useStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
		borderTop: `1px solid ${theme.typography.button.disabledColor}`,
		"& .MuiAccordionSummary-root .MuiSvgIcon-root": {
			color: theme.palette.grey.D100,
		},
		"& .MuiAccordion-root:last-child": {
			boxShadow: "none",
		},
	},
	heading: {
		fontSize: theme.typography.pxToRem(15),
		fontWeight: theme.typography.fontWeightRegular,
	},
	title: {
		color: theme.palette.grey.D100,
	},
	subtitle: {
		textTransform: "capitalize",
	},
}))

const ConceptList = ({ concepts }) => {
	const classes = useStyles()
	const [t] = useTranslation("global")
	const [expanded, setExpanded] = useState(false)

	const handleChange = (panel) => (event, isExpanded) => {
		setExpanded(isExpanded ? panel : false)
	}

	return (
		<div className={classes.root}>
			{concepts?.length > 0 &&
				concepts.map((concept) => (
					<Accordion key={concept?.id} expanded={expanded === concept?.id} onChange={handleChange(concept?.id)}>
						<AccordionSummary
							expandIcon={<ExpandMoreIcon />}
							aria-controls={`panel${concept?.id}a-content`}
							id={`panel${concept?.id}a-header`}
						>
							<Typography className={classes.heading}>{concept?.description}</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<Typography className={classes.subtitle}>
								<span className={classes.title}>{t("review.reviewMetadata.target_terms")} - </span>{" "}
								{concept?.visual?.terms?.join(", ")}
							</Typography>
						</AccordionDetails>
					</Accordion>
				))}
		</div>
	)
}

export default ConceptList
